export default __webpack_public_path__ + "static/ot_card_2-adb766ff65a1602785eba0eb014d970a.png";